import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 md:py-36 bg-stone-900">
      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <span className="text-xs font-medium tracking-[0.3em] text-stone-400 uppercase mb-6 block">
          Votre prochain projet
        </span>
        <h2 className="font-serif-display text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-8">
          Contactez-nous pour discuter de votre projet
        </h2>
        <p className="text-base md:text-lg text-stone-400 leading-relaxed max-w-xl mx-auto mb-12">
          Que vous soyez une entreprise ou un particulier, nous proposons des solutions de design graphique adaptées à vos besoins à Bordeaux.
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-3 px-8 py-4 bg-white text-stone-900 text-sm font-semibold rounded-full hover:bg-stone-100 transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          Prendre contact
          <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center" />
        </Link>
      </div>
    </section>
  );
}